/** The "WORDLOOM" wordmark spelled in tiles that bob in gently. */
import clsx from 'clsx';
import { LETTER_VALUES } from '@wordloom/engine';
import { MiniTile } from './Tile';
import './Wordmark.css';

const WORD = 'WORDLOOM';

export function Wordmark({ size = 'lg' }: { size?: 'lg' | 'sm' }) {
  return (
    <span className={clsx('wordmark', `wordmark--${size}`)} role="img" aria-label="Wordloom">
      {[...WORD].map((ch, i) => (
        <span key={i} className="wordmark__slot" style={{ ['--i' as string]: i }} aria-hidden="true">
          <MiniTile letter={ch} value={LETTER_VALUES[ch] ?? 1} className="wordmark__tile" />
        </span>
      ))}
    </span>
  );
}
